const SET_OBS_IS_VISIBLE = 'SET_OBS_IS_VISIBLE';

export { SET_OBS_IS_VISIBLE };



// WEBPACK FOOTER //
// ./src/containers/Inputs/OBS/constants.js